<div class="w-full relative">
  @if(isLoading()){
  <div class="bg-white rounded shadow-xl rounded-xl h-[400px]">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
  }@else {
  <div
    class="flex-1 bg-white rounded shadow-xl rounded-xl"
    [ngClass]="cssClass()"
  >
    <div class="p-6 flex flex-col h-full">
      <div class="mb-8">
        <div class="flex justify-between items-center mb-8">
          <span class="text-2xl font-bold text-primary">{{ chartCase() }}</span>
        </div>
        <hr class="border-gray-300" />
      </div>

      <!-- end::Header-->

      <!-- begin::Body-->
      <div class="card-body min-h-[315px]">
        <!-- begin::Chart-->
        <div #chartRef [style.height]="'100%'">
          @if (hasChartData){
          <apx-chart
            [series]="chartOptions.series!"
            [chart]="chartOptions.chart!"
            [dataLabels]="chartOptions.dataLabels!"
            [plotOptions]="chartOptions.plotOptions!"
            [yaxis]="chartOptions.yaxis!"
            [xaxis]="chartOptions.xaxis!"
            [subtitle]="chartOptions.subtitle!"
            [colors]="chartOptions.colors!"
            [states]="chartOptions.states!"
            [title]="chartOptions.title!"
            [tooltip]="chartOptions.tooltip!"
            [labels]="chartOptions.labels"
            [legend]="chartOptions.legend"
          ></apx-chart>
          } @else {
          <div class="flex items-start justify-center min-h-[315px] pt-30">
            <span class="text-600 font-bold text-lg text-center">
              {{ 'REPORTS.NO_DATA_FOUND' | translate }}
            </span>
          </div>
          }
        </div>
        <!-- end::Chart-->
      </div>
    </div>
  </div>
  }
</div>
